import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { ExpectedError } from '@adornis/validation/errors/ExpectedError.js';
import { NotificationStatus } from '../db/UserNotification.js';
import { requireClosableNotification } from '../server/notification-access.js';

/** Only the two states a user may set by hand; answering goes through its own mutation. */
const MANUAL_STATES: string[] = [NotificationStatus.RESOLVED, NotificationStatus.DISMISSED];

/**
 * Close a notification by hand: `Erledigt` (dealt with) or `Verworfen` (not relevant).
 *
 * The distinction matters beyond bookkeeping — a dismissed notification stays dismissed
 * when the same problem is raised again, so a deliberate decision is not overruled on
 * every extraction run (see `raiseNotification.ts`).
 */
export const setNotificationStatus = registerMutation({
  type: () => Boolean,
  operationName: 'setNotificationStatus',
  resolve: (notificationID: string, status: string) => {
    return async () => {
      if (!MANUAL_STATES.includes(status))
        throw new ExpectedError('Ungültiger Status.', { translationKey: 'notification.invalid_status' });
      const { collection } = await requireClosableNotification(notificationID);
      const now = new Date();
      await collection.updateOne(
        { _id: notificationID },
        {
          $set: { status, updatedAt: now, readAt: now },
          $push: { history: `${now.toISOString()} — Status auf "${status}" gesetzt.` },
        },
      );
      return true;
    };
  },
  params: [
    { name: 'notificationID', type: () => String },
    { name: 'status', type: () => String },
  ],
});
